import React from 'react';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import ColumnLayout from '@amzn/awsui-components-react/polaris/column-layout';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Spinner from '@amzn/awsui-components-react/polaris/spinner';
import { useAnalyticsData } from '../../../hooks';

const MetricsOverview: React.FC = () => {
  const { data, loading, error } = useAnalyticsData();

  if (loading) {
    return (
      <Container>
        <Box textAlign="center" padding="l">
          <Spinner size="large" />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Box color="text-status-error" textAlign="center" padding="l">
          Error loading metrics: {error}
        </Box>
      </Container>
    );
  }

  const totalJobs = (data && data.completeSummary && data.completeSummary.totalJobs) || 0;
  const successfulJobs = (data && data.completeSummary && data.completeSummary.successfulJobs) || 0;
  const failedJobs = (data && data.completeSummary && data.completeSummary.failedJobs) || 0;
  const totalMinutes = (data && data.completeSummary && data.completeSummary.totalMinutesTranscribed) || 0;
  const totalCost = (data && data.completeSummary && data.completeSummary.totalCost) || 0;

  return (
    <Container
      header={
        <Header variant="h2">
          Key Metrics Overview
        </Header>
      }
    >
      <ColumnLayout columns={4} variant="text-grid">
        <SpaceBetween direction="vertical" size="xs">
          <Box variant="awsui-key-label">Total Users</Box>
          <Box fontSize="display-l" fontWeight="bold">
            {(data && data.userMetrics && data.userMetrics.totalUsers) || 0}
          </Box>
          <Box variant="small" color="text-status-success">
            {(data && data.userMetrics && data.userMetrics.activeUsers30d) || 0} active (30d)
          </Box>
        </SpaceBetween>

        <SpaceBetween direction="vertical" size="xs">
          <Box variant="awsui-key-label">Total Jobs (All Time)</Box>
          <Box fontSize="display-l" fontWeight="bold">
            {totalJobs}
          </Box>
          <Box variant="small" color="text-status-success">
            {successfulJobs} successful, {failedJobs} failed
          </Box>
        </SpaceBetween>

        <SpaceBetween direction="vertical" size="xs">
          <Box variant="awsui-key-label">Minutes Transcribed (All Time)</Box>
          <Box fontSize="display-l" fontWeight="bold">
            {Math.round(totalMinutes).toLocaleString()}
          </Box>
          <Box variant="small" color="text-status-info">
            {Math.round(totalMinutes / 60).toLocaleString()} hours
          </Box>
        </SpaceBetween>

        <SpaceBetween direction="vertical" size="xs">
          <Box variant="awsui-key-label">Total Cost (All Time)</Box>
          <Box fontSize="display-l" fontWeight="bold">
            ${totalCost.toFixed(2)}
          </Box>
          <Box variant="small" color="text-status-success">
            Complete historical data
          </Box>
        </SpaceBetween>
      </ColumnLayout>
    </Container>
  );
};

export default MetricsOverview;
